import Lemit from './Index.vue';

export const routes = [
  {
    path: 'consulta-lemit',
    name: 'talkvia_lemit',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: Lemit,
  },
];
